import { useMutation, useQueryClient } from '@tanstack/react-query'

import { ErrorResponse } from '@sparkai/utils'

import { apiClient } from '../../../apiClient'
import { USE_GET_PROGRAM_ONTOLOGY_KEY } from '../useGetCurrentProgramOntologyConfig'
import { OntologyFeature } from './ontologyFeatureTypings'
import { USE_ONTOLOGY_FEATURE_BY_ID_KEY } from './useGetOntologyFeatureById'

type CreateOntologyFeaturePayload = Omit<OntologyFeature, 'instances' | 'featureId' | 'programId'>

export function useCreateOntologyFeature(programId?: string, onSuccess?: () => void) {
  const queryClient = useQueryClient()

  return useMutation<unknown, ErrorResponse, CreateOntologyFeaturePayload>({
    mutationFn: async (values: CreateOntologyFeaturePayload) => {
      const { data } = await apiClient.post(`/int/v3/programs/${programId}/ontology`, values)
      return data
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [USE_GET_PROGRAM_ONTOLOGY_KEY] })
      queryClient.invalidateQueries({ queryKey: [USE_ONTOLOGY_FEATURE_BY_ID_KEY] })

      onSuccess?.()
    },
  })
}
